export default {
  getModuleTask: state => state.moduleTask,
};
